import { useRouteMatch, Route, Switch } from 'react-router-dom'

import AdditionPage from '@pages/Branch/AdditionPage'
import BranchContractPage from '@pages/Branch/ContractPage'
import SpacePage from '@pages/Branch/SpacePage'
import NotFoundPage from '@pages/Error/NotFoundPage'

export default function BranchContractRouter(): JSX.Element {
  const { url } = useRouteMatch()

  return (
    <Switch>
      <Route path={`${url}/list`}>
        <BranchContractPage />
      </Route>
      <Route path={`${url}/space`}>
        <SpacePage />
      </Route>
      <Route path={`${url}/addition`}>
        <AdditionPage />
      </Route>
      <Route>
        <NotFoundPage />
      </Route>
    </Switch>
  )
}
